import { baseClient } from '../common';
import { PlaceModel } from './place.model';

const apiUrl = `/api/places`;

export const placeClient = {
  get: (shopId: string): Promise<PlaceModel[]> => {
    return baseClient.get<PlaceModel[]>(`${apiUrl}/${shopId}`);
  },
};
